import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { SiteHeaderComponent } from './layout/site-header/site-header.component';
import { LandingComponent } from './landing/landing.component';
import { SiteFooterComponent } from './layout/site-footer/site-footer.component';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { NgOptimizedImage } from '@angular/common';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { authenticationInterceptor } from './shared/interceptors/authentication.interceptor';
import { AlertButtonComponent } from './features/rates/components/alert-button/alert-button.component';
import { HideOnScrollDownDirective } from './shared/directives/hide-on-scroll-down.directive';

@NgModule({
  declarations: [AppComponent, SiteHeaderComponent, SiteFooterComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgOptimizedImage,
    // standalone components
    AlertButtonComponent,
    LandingComponent,
    HideOnScrollDownDirective,
  ],
  providers: [
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher,
    },
    provideHttpClient(withInterceptors([authenticationInterceptor])),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
